import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=27b6c4f1&scoped=true"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=27b6c4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_a4ajn4nredche26m3ww6ixpcm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6c4f1",
  null
  
)

export default component.exports